/**
 * SparteBadge — ported from v0 components/brokly/sparte-badge.tsx.
 * Sparte (insurance line) as a neutral outline badge with a Lucide icon.
 * Keyword-based icon selection so composite sparte names ("Kollektiv-Krankentaggeld") match.
 */
import {
  Shield,
  Laptop,
  Scale,
  Building2,
  Truck,
  Wrench,
  Briefcase,
  HeartPulse,
  Activity,
  Package,
  type LucideIcon,
} from 'lucide-react';
import { cn } from '../../../lib/cn';

export function iconForSparte(sparte: string): LucideIcon {
  const s = sparte.toLowerCase();
  if (s.includes('cyber')) return Laptop;
  if (s.includes('rechtsschutz')) return Scale;
  if (s.includes('gebäude') || s.includes('gebaeude')) return Building2;
  if (s.includes('transport') || s.includes('flotte')) return Truck;
  if (s.includes('maschin')) return Wrench;
  if (s.includes('kranken') || s.includes('taggeld')) return HeartPulse;
  if (s.includes('unterbruch')) return Activity;
  if (s.includes('sach')) return Package;
  if (s.includes('haftpflicht') || s.includes('betrieb')) return Briefcase;
  return Shield;
}

export function SparteBadge({ sparte, className }: { sparte: string; className?: string }) {
  const Icon = iconForSparte(sparte);
  return (
    <span
      className={cn(
        'inline-flex h-5 w-fit max-w-full shrink-0 items-center gap-1 rounded-md border border-border bg-background px-1.5 text-xs font-medium whitespace-nowrap text-muted-foreground',
        className,
      )}
    >
      <Icon className="size-3 shrink-0" aria-hidden />
      <span className="truncate">{sparte}</span>
    </span>
  );
}
